import React, { useState } from "react";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Loading from "../common/Loading";
import TagInput from "../common/TagInput";
import { customToast as toast } from "../../utils";

import * as customerActions from "../../actions/customerActions";

const MaintenanceList = ({
  data,
  loading,
  actions,
  customers,
  pages,
  sorted,
  page,
  pageSize,
  setData,
  onSortedChange,
  onPageSizeChange,
  onPageChange
}) => {
  const [error, setError] = useState({ isError: false, errorMsg: "", id: "" });

  const handleChangeTags = async (name, value, newName, customer) => {
    const allAlternativeNames = customers
      .map((c) => c.alternative_names)
      .flat();
    const matchingNames = allAlternativeNames.filter((a_n) => a_n === newName);

    const isNameExistsError = !!(newName?.length && matchingNames?.length > 0);
    const isNameEntryError = newName?.length === 0;

    if (isNameExistsError) {
      setError({
        id: customer?._id,
        isError: true,
        errorMsg: "This name already exists as an alternative name"
      });
    }

    if (isNameEntryError) {
      setError({
        id: customer?._id,
        isError: true,
        errorMsg: "Tag must have at least 1 character"
      });
    }

    // when newName === undefined it is being removed
    if (newName === undefined || (!isNameExistsError && !isNameEntryError)) {
      setError({ isError: false, errorMsg: "", id: "" });
      const updatedCustomer = {
        ...customer,
        alternative_names: value
      };

      const updatedCustomers = data.map((c) =>
        c._id === updatedCustomer._id ? updatedCustomer : c
      );

      try {
        await actions.updateCustomer({
          ...updatedCustomer,
          id: customer._id
        });

        setData(updatedCustomers);
      } catch (err) {
        toast.error(
          "Error updating Alternative Names, please contact support."
        );
      }
    }
  };

  const columns = [
    {
      id: "name",
      Header: "Customer Name",
      accessor: "name",
      width: 250,
      Cell: ({ value }) => value || "--"
    },
    {
      id: "status",
      Header: "Status",
      accessor: "status",
      width: 80,
      Cell: ({ value }) => (value ? "Active" : "Inactive")
    },
    {
      id: "alternative_names",
      Header: "Alternative Names",
      Cell: (value) => (
        <div
          style={{
            width: "100%",
            height: "100%"
          }}
        >
          <TagInput
            id={value?.original?._id}
            disabled={loading}
            name="alternative_names"
            placeholder="Type name and press enter..."
            errorMsg={error.errorMsg}
            isError={error.isError && error.id === value?.original?._id}
            tagId={value?.original?._id}
            errorId={error.id}
            values={value?.original?.alternative_names || []}
            maxWidth="100%"
            onChange={(name, val, newName) =>
              handleChangeTags(name, val, newName, value?.original)
            }
          />
        </div>
      )
    }
  ];

  return data && data?.length && !loading ? (
    <ReactTable
      data={data}
      loading={loading}
      LoadingComponent={() => <Loading active={loading} />}
      showPageSizeOptions
      showPagination
      noDataText="No rows found"
      manual
      sorted={sorted}
      columns={columns}
      pageSize={Math.min(data.length, pageSize)}
      pages={pages}
      page={page}
      onSortedChange={onSortedChange}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};

MaintenanceList.propTypes = {
  data: PropTypes.array,
  customers: PropTypes.array,
  actions: PropTypes.object,
  loading: PropTypes.bool,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sorted: PropTypes.array,
  setData: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onSortedChange: PropTypes.func
};

MaintenanceList.defaultProps = {
  data: [],
  loading: false
};

function mapStatesToProps(state) {
  return {
    customers: state.reducers.customers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(MaintenanceList);
